// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==================== ROOT VARIABLES ==================== */

:root {
  /* Light Theme */
  --bg-primary: #f8f9fa;
  --bg-secondary: #ffffff;
  --bg-tertiary: #f9fafb;
  --bg-hover: #f3f4f6;

  --text-primary: #111827;
  --text-secondary: #6b7280;
  --text-tertiary: #9ca3af;
  
  --border-primary: #e5e7eb;
  --border-secondary: #d1d5db;
  
  --accent: #3b82f6;
  --accent-hover: #2563eb;
  --accent-light: #dbeafe;
  
  --success: #10b981;
  --danger: #ef4444;
  --danger-hover: #dc2626;
  
  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.1);
  --shadow-md: 0 4px 12px rgba(0, 0, 0, 0.15);
  --shadow-lg: 0 8px 24px rgba(0, 0, 0, 0.3);
}

[data-theme="dark"] {
  /* Dark Theme */
  --bg-primary: #0f172a;
  --bg-secondary: #1e293b;
  --bg-tertiary: #334155;
  --bg-hover: #475569;
  
  --text-primary: #f1f5f9;
  --text-secondary: #cbd5e1;
  --text-tertiary: #94a3b8;
  
  --border-primary: #334155;
  --border-secondary: #475569;
  
  --accent: #3b82f6;
  --accent-hover: #60a5fa;
  --accent-light: #1e3a8a;
  
  --success: #10b981;
  --danger: #ef4444;
  --danger-hover: #f87171;
  
  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.3);
  --shadow-md: 0 4px 12px rgba(0, 0, 0, 0.4);
  --shadow-lg: 0 8px 24px rgba(0, 0, 0, 0.6);
}

/* ==================== BASE ==================== */

* {
  box-sizing: border-box;
}

.assets-page {
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px;
  min-height: 100vh;
  background: transparent;
  transition: background 0.3s ease;
}

/* ==================== TOAST ==================== */

.toast {
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  box-shadow: var(--shadow-md);
  z-index: 1000;
  animation: slideIn 0.3s ease;
}

.toast.success {
  background: var(--success);
  color: white;
}

.toast.error {
  background: var(--danger);
  color: white;
}

@keyframes slideIn {
  from {
    transform: translateX(400px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* ==================== TOOLBAR ==================== */

.assets-toolbar {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 12px;
  padding: 12px;
  background: var(--bg-secondary);
  border-radius: 12px;
  box-shadow: var(--shadow-sm);
  margin-bottom: 20px;
  transition: all 0.3s ease;
}

.toolbar-search {
  grid-column: 1;
}

.toolbar-search input {
  width: 100%;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid var(--border-primary);
  background: var(--bg-secondary);
  color: var(--text-primary);
  font-size: 14px;
  transition: all 0.2s;
}

.toolbar-search input::placeholder {
  color: var(--text-tertiary);
}

.toolbar-search input:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);
}

.toolbar-filters {
  grid-column: 1;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.toolbar-filters select {
  flex: 1 1;
  min-width: 120px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid var(--border-primary);
  background: var(--bg-secondary);
  color: var(--text-primary);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.toolbar-filters select:focus {
  outline: none;
  border-color: var(--accent);
}

.toolbar-actions {
  grid-column: 1;
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
}

.view-toggle {
  display: flex;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid var(--border-primary);
}

.view-toggle button {
  padding: 10px 14px;
  border: none;
  background: var(--bg-secondary);
  cursor: pointer;
  font-size: 16px;
  transition: all 0.2s;
  border-right: 1px solid var(--border-primary);
}

.view-toggle button:last-child {
  border-right: none;
}

.view-toggle button.active {
  background: var(--accent);
  color: white;
}

.view-toggle button:hover:not(.active) {
  background: var(--bg-hover);
}

.edit-button {
  padding: 10px 16px;
  border-radius: 8px;
  border: 1px solid var(--border-primary);
  background: var(--bg-secondary);
  color: var(--text-primary);
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
  white-space: nowrap;
}

.edit-button:hover {
  background: var(--bg-hover);
}

.add-asset {
  grid-column: 2;
  grid-row: 1 / -1;
  padding: 10px 20px;
  border-radius: 8px;
  background: var(--accent);
  color: white;
  border: 1px solid var(--accent);
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
  white-space: nowrap;
  align-self: start;
}

.add-asset:hover {
  background: var(--accent-hover);
  border-color: var(--accent-hover);
}

/* ==================== EMPTY STATE ==================== */

.empty-state {
  text-align: center;
  padding: 60px 20px;
  background: var(--bg-secondary);
  border-radius: 12px;
  box-shadow: var(--shadow-sm);
}

.empty-state h2 {
  color: var(--text-secondary);
  margin-bottom: 20px;
  font-weight: 500;
  font-size: 18px;
}

.empty-state button {
  padding: 12px 24px;
  background: var(--accent);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.empty-state button:hover {
  background: var(--accent-hover);
  transform: translateY(-1px);
}

/* ==================== GRID VIEW ==================== */

.assets-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 16px;
}

.asset-card {
  position: relative;
  background: var(--bg-secondary);
  border-radius: 10px;
  overflow: hidden;
  box-shadow: var(--shadow-sm);
  transition: all 0.2s;
}

.asset-card:hover {
  box-shadow: var(--shadow-md);
  transform: translateY(-2px);
}

.asset-card input[type="checkbox"] {
  position: absolute;
  top: 10px;
  left: 10px;
  width: 18px;
  height: 18px;
  cursor: pointer;
  z-index: 10;
}

.asset-card .badge {
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  z-index: 10;
}

.badge.image {
  background: var(--accent-light);
  color: var(--accent);
}

.badge.video {
  background: #fce7f3;
  color: #9f1239;
  width: auto;
}

[data-theme="dark"] .badge.video {
  background: #831843;
  color: #fbcfe8;
}

.asset-card img,
.asset-card video {
  width: 100%;
  height: 180px;
  object-fit: cover;
  display: block;
}

.asset-card .playlist-select {
  width: 100%;
  padding: 10px 12px;
  border: none;
  border-top: 1px solid var(--border-primary);
  font-size: 13px;
  background: var(--bg-secondary);
  color: var(--text-primary);
  cursor: pointer;
  transition: all 0.2s;
}

.asset-card .playlist-select:hover {
  background: var(--bg-hover);
}

.asset-card .playlist-select:focus {
  outline: none;
  background: var(--bg-tertiary);
}

/* ==================== LIST VIEW ==================== */

.assets-table {
  background: var(--bg-secondary);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: var(--shadow-sm);
}

.table-header {
  display: grid;
  grid-template-columns: 2fr 0.8fr 1fr;
  gap: 12px;
  padding: 14px 16px;
  background: var(--bg-tertiary);
  border-bottom: 1px solid var(--border-primary);
  font-size: 12px;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.table-row {
  border-bottom: 1px solid var(--border-primary);
  transition: all 0.2s;
  cursor: pointer;
}

.table-row:hover {
  background: var(--bg-hover);
}

.table-row:last-child {
  border-bottom: none;
}

.row-main {
  display: grid;
  grid-template-columns: 2fr 0.8fr 1fr;
  gap: 12px;
  padding: 12px 16px;
  align-items: center;
}

.row-expanded {
  display: none;
  padding: 0 16px 16px 16px;
  gap: 12px;
}

.table-row.expanded .row-expanded {
  display: flex;
  animation: slideDown 0.2s ease;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.asset-cell {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.asset-cell input[type="checkbox"] {
  width: 16px;
  height: 16px;
  cursor: pointer;
  flex-shrink: 0;
}

.asset-cell img,
.asset-cell video {
  width: 45px;
  height: 45px;
  object-fit: cover;
  border-radius: 6px;
  flex-shrink: 0;
}

.asset-cell span {
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.row-main > span {
  font-size: 13px;
  color: var(--text-secondary);
}

.row-expanded .playlist-select {
  flex: 1 1;
  padding: 10px 12px;
  border: 1px solid var(--border-primary);
  border-radius: 8px;
  font-size: 13px;
  background: var(--bg-secondary);
  color: var(--text-primary);
  cursor: pointer;
  transition: all 0.2s;
}

.row-expanded .playlist-select:hover {
  border-color: var(--accent);
}

.row-expanded .playlist-select:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.row-expanded button.danger {
  padding: 10px 20px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
}

.row-expanded button.danger:hover {
  background: #fef2f2;
  border-color: #fecaca;
  color: var(--danger);
}

[data-theme="dark"] .row-expanded button.danger:hover {
  background: #7f1d1d;
  border-color: #991b1b;
}

/* ==================== BULK ACTION BAR ==================== */

.bulk-bar {
  position: fixed;
  bottom: calc(80px + env(safe-area-inset-bottom));
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 20px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  color: var(--text-primary);
  border-radius: 10px;
  box-shadow: var(--shadow-lg);
  z-index: 999;
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from {
    transform: translateX(-50%) translateY(100px);
    opacity: 0;
  }
  to {
    transform: translateX(-50%) translateY(0);
    opacity: 1;
  }
}

.bulk-bar span {
  font-size: 14px;
  font-weight: 500;
}

.bulk-bar button {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.bulk-bar button.danger {
  background: var(--danger);
  color: white;
}

.bulk-bar button.danger:hover {
  background: var(--danger-hover);
}

/* ==================== MODAL ==================== */

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.modal {
  background: var(--bg-secondary);
  border-radius: 12px;
  padding: 24px;
  max-width: 600px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: var(--shadow-lg);
  animation: scaleIn 0.2s ease;
}

@keyframes scaleIn {
  from {
    transform: scale(0.9);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

.modal h2 {
  margin: 0 0 20px 0;
  font-size: 20px;
  font-weight: 600;
  color: var(--text-primary);
}

.modal .drop-zone {
  border: 2px dashed var(--border-secondary);
  border-radius: 10px;
  padding: 40px 20px;
  text-align: center;
  color: var(--text-secondary);
  font-size: 14px;
  margin-bottom: 16px;
  transition: all 0.2s;
  cursor: pointer;
}

.modal .drop-zone:hover {
  border-color: var(--accent);
  background: var(--accent-light);
  color: var(--accent);
}

.modal input[type="file"] {
  margin-bottom: 16px;
  padding: 10px;
  width: 100%;
  border: 1px solid var(--border-primary);
  border-radius: 8px;
  font-size: 13px;
  background: var(--bg-secondary);
  color: var(--text-primary);
  cursor: pointer;
}

.modal .progress {
  width: 100%;
  height: 6px;
  background: var(--bg-tertiary);
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 16px;
}

.modal .progress > div {
  height: 100%;
  background: linear-gradient(90deg, var(--accent), var(--accent-hover));
  transition: width 0.3s ease;
  border-radius: 6px;
}

.modal button {
  width: 100%;
  padding: 12px 20px;
  border: 1px solid var(--border-primary);
  border-radius: 8px;
  background: var(--bg-secondary);
  color: var(--text-primary);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.modal button.primary {
  background: var(--accent);
  color: white;
  border-color: var(--accent);
}

.modal button.primary:hover:not(:disabled) {
  background: var(--accent-hover);
  border-color: var(--accent-hover);
}

.modal button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ==================== UPLOAD PREVIEW GRID ==================== */

.upload-preview-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
  gap: 10px;
  margin-bottom: 16px;
}

.upload-preview-card {
  background: var(--bg-tertiary);
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid var(--border-primary);
}

.upload-preview-card img,
.upload-preview-card video {
  width: 100%;
  height: 110px;
  object-fit: cover;
  display: block;
}

.upload-preview-card span {
  display: block;
  padding: 6px;
  font-size: 11px;
  color: var(--text-secondary);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.upload-status {
  margin-top: 12px;
}

.upload-status p {
  font-size: 13px;
  color: var(--text-secondary);
  margin-bottom: 8px;
}

.progress-bar {
  width: 100%;
  height: 6px;
  background: var(--bg-tertiary);
  border-radius: 6px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, var(--accent), var(--success));
  transition: width 0.3s ease;
}

/* ==================== RESPONSIVE ==================== */

@media (max-width: 1024px) {
  .assets-grid {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  }

  .table-header,
  .row-main {
    grid-template-columns: 2fr 0.8fr 1fr;
    gap: 10px;
    font-size: 11px;
  }
}

@media (max-width: 768px) {
  .assets-toolbar {
    grid-template-columns: 1fr;
  }

  .toolbar-search,
  .toolbar-filters,
  .toolbar-actions,
  .add-asset {
    grid-column: 1;
    grid-row: auto;
  }

  .add-asset {
    align-self: stretch;
  }

  .table-header {
    display: none;
  }

  .row-main {
    display: block;
    padding: 16px;
  }

  .table-row {
    border-radius: 12px;
    margin-bottom: 12px;
  }

  .asset-cell {
    margin-bottom: 12px;
  }

  .row-main > span {
    display: block;
    margin-bottom: 8px;
  }

  .row-expanded {
    padding: 0 16px 16px 16px;
    flex-direction: column;
  }

  .row-expanded .playlist-select,
  .row-expanded button.danger {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/assets.css"],"names":[],"mappings":"AAAA,6DAA6D;;AAE7D;EACE,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;;EAEnB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;;EAExB,yBAAyB;EACzB,2BAA2B;;EAE3B,iBAAiB;EACjB,uBAAuB;EACvB,uBAAuB;;EAEvB,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;;EAEvB,yCAAyC;EACzC,2CAA2C;EAC3C,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;;EAEnB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;;EAExB,yBAAyB;EACzB,2BAA2B;;EAE3B,iBAAiB;EACjB,uBAAuB;EACvB,uBAAuB;;EAEvB,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;;EAEvB,yCAAyC;EACzC,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA,mDAAmD;;AAEnD;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA,oDAAoD;;AAEpD;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,sDAAsD;;AAEtD;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,uCAAuC;EACvC,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,uCAAuC;EACvC,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uCAAuC;EACvC,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA,0DAA0D;;AAE1D;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA,wDAAwD;;AAExD;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,2CAA2C;EAC3C,eAAe;EACf,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA,wDAAwD;;AAExD;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,kBAAkB;EAClB,8BAA8B;EAC9B,8CAA8C;EAC9C,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,8CAA8C;EAC9C,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,uCAAuC;EACvC,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,uCAAuC;EACvC,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,8DAA8D;;AAE9D;EACE,eAAe;EACf,gDAAgD;EAChD,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,uCAAuC;EACvC,0BAA0B;EAC1B,mBAAmB;EACnB,4BAA4B;EAC5B,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE;IACE,6CAA6C;IAC7C,UAAU;EACZ;EACA;IACE,yCAAyC;IACzC,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA,oDAAoD;;AAEpD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,uCAAuC;EACvC,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,sEAAsE;EACtE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,uCAAuC;EACvC,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,kEAAkE;;AAElE;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iEAAiE;EACjE,2BAA2B;AAC7B;;AAEA,yDAAyD;;AAEzD;EACE;IACE,4DAA4D;EAC9D;;EAEA;;IAEE,oCAAoC;IACpC,SAAS;IACT,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;;;;IAIE,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":["/* ==================== ROOT VARIABLES ==================== */\n\n:root {\n  /* Light Theme */\n  --bg-primary: #f8f9fa;\n  --bg-secondary: #ffffff;\n  --bg-tertiary: #f9fafb;\n  --bg-hover: #f3f4f6;\n\n  --text-primary: #111827;\n  --text-secondary: #6b7280;\n  --text-tertiary: #9ca3af;\n  \n  --border-primary: #e5e7eb;\n  --border-secondary: #d1d5db;\n  \n  --accent: #3b82f6;\n  --accent-hover: #2563eb;\n  --accent-light: #dbeafe;\n  \n  --success: #10b981;\n  --danger: #ef4444;\n  --danger-hover: #dc2626;\n  \n  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.1);\n  --shadow-md: 0 4px 12px rgba(0, 0, 0, 0.15);\n  --shadow-lg: 0 8px 24px rgba(0, 0, 0, 0.3);\n}\n\n[data-theme=\"dark\"] {\n  /* Dark Theme */\n  --bg-primary: #0f172a;\n  --bg-secondary: #1e293b;\n  --bg-tertiary: #334155;\n  --bg-hover: #475569;\n  \n  --text-primary: #f1f5f9;\n  --text-secondary: #cbd5e1;\n  --text-tertiary: #94a3b8;\n  \n  --border-primary: #334155;\n  --border-secondary: #475569;\n  \n  --accent: #3b82f6;\n  --accent-hover: #60a5fa;\n  --accent-light: #1e3a8a;\n  \n  --success: #10b981;\n  --danger: #ef4444;\n  --danger-hover: #f87171;\n  \n  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.3);\n  --shadow-md: 0 4px 12px rgba(0, 0, 0, 0.4);\n  --shadow-lg: 0 8px 24px rgba(0, 0, 0, 0.6);\n}\n\n/* ==================== BASE ==================== */\n\n* {\n  box-sizing: border-box;\n}\n\n.assets-page {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 20px;\n  min-height: 100vh;\n  background: transparent;\n  transition: background 0.3s ease;\n}\n\n/* ==================== TOAST ==================== */\n\n.toast {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  padding: 12px 20px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  box-shadow: var(--shadow-md);\n  z-index: 1000;\n  animation: slideIn 0.3s ease;\n}\n\n.toast.success {\n  background: var(--success);\n  color: white;\n}\n\n.toast.error {\n  background: var(--danger);\n  color: white;\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateX(400px);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n/* ==================== TOOLBAR ==================== */\n\n.assets-toolbar {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 12px;\n  padding: 12px;\n  background: var(--bg-secondary);\n  border-radius: 12px;\n  box-shadow: var(--shadow-sm);\n  margin-bottom: 20px;\n  transition: all 0.3s ease;\n}\n\n.toolbar-search {\n  grid-column: 1;\n}\n\n.toolbar-search input {\n  width: 100%;\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid var(--border-primary);\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  font-size: 14px;\n  transition: all 0.2s;\n}\n\n.toolbar-search input::placeholder {\n  color: var(--text-tertiary);\n}\n\n.toolbar-search input:focus {\n  outline: none;\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);\n}\n\n.toolbar-filters {\n  grid-column: 1;\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.toolbar-filters select {\n  flex: 1;\n  min-width: 120px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid var(--border-primary);\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.toolbar-filters select:focus {\n  outline: none;\n  border-color: var(--accent);\n}\n\n.toolbar-actions {\n  grid-column: 1;\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.view-toggle {\n  display: flex;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid var(--border-primary);\n}\n\n.view-toggle button {\n  padding: 10px 14px;\n  border: none;\n  background: var(--bg-secondary);\n  cursor: pointer;\n  font-size: 16px;\n  transition: all 0.2s;\n  border-right: 1px solid var(--border-primary);\n}\n\n.view-toggle button:last-child {\n  border-right: none;\n}\n\n.view-toggle button.active {\n  background: var(--accent);\n  color: white;\n}\n\n.view-toggle button:hover:not(.active) {\n  background: var(--bg-hover);\n}\n\n.edit-button {\n  padding: 10px 16px;\n  border-radius: 8px;\n  border: 1px solid var(--border-primary);\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.edit-button:hover {\n  background: var(--bg-hover);\n}\n\n.add-asset {\n  grid-column: 2;\n  grid-row: 1 / -1;\n  padding: 10px 20px;\n  border-radius: 8px;\n  background: var(--accent);\n  color: white;\n  border: 1px solid var(--accent);\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s;\n  white-space: nowrap;\n  align-self: start;\n}\n\n.add-asset:hover {\n  background: var(--accent-hover);\n  border-color: var(--accent-hover);\n}\n\n/* ==================== EMPTY STATE ==================== */\n\n.empty-state {\n  text-align: center;\n  padding: 60px 20px;\n  background: var(--bg-secondary);\n  border-radius: 12px;\n  box-shadow: var(--shadow-sm);\n}\n\n.empty-state h2 {\n  color: var(--text-secondary);\n  margin-bottom: 20px;\n  font-weight: 500;\n  font-size: 18px;\n}\n\n.empty-state button {\n  padding: 12px 24px;\n  background: var(--accent);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.empty-state button:hover {\n  background: var(--accent-hover);\n  transform: translateY(-1px);\n}\n\n/* ==================== GRID VIEW ==================== */\n\n.assets-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n  gap: 16px;\n}\n\n.asset-card {\n  position: relative;\n  background: var(--bg-secondary);\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: var(--shadow-sm);\n  transition: all 0.2s;\n}\n\n.asset-card:hover {\n  box-shadow: var(--shadow-md);\n  transform: translateY(-2px);\n}\n\n.asset-card input[type=\"checkbox\"] {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  z-index: 10;\n}\n\n.asset-card .badge {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  z-index: 10;\n}\n\n.badge.image {\n  background: var(--accent-light);\n  color: var(--accent);\n}\n\n.badge.video {\n  background: #fce7f3;\n  color: #9f1239;\n  width: auto;\n}\n\n[data-theme=\"dark\"] .badge.video {\n  background: #831843;\n  color: #fbcfe8;\n}\n\n.asset-card img,\n.asset-card video {\n  width: 100%;\n  height: 180px;\n  object-fit: cover;\n  display: block;\n}\n\n.asset-card .playlist-select {\n  width: 100%;\n  padding: 10px 12px;\n  border: none;\n  border-top: 1px solid var(--border-primary);\n  font-size: 13px;\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.asset-card .playlist-select:hover {\n  background: var(--bg-hover);\n}\n\n.asset-card .playlist-select:focus {\n  outline: none;\n  background: var(--bg-tertiary);\n}\n\n/* ==================== LIST VIEW ==================== */\n\n.assets-table {\n  background: var(--bg-secondary);\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: var(--shadow-sm);\n}\n\n.table-header {\n  display: grid;\n  grid-template-columns: 2fr 0.8fr 1fr;\n  gap: 12px;\n  padding: 14px 16px;\n  background: var(--bg-tertiary);\n  border-bottom: 1px solid var(--border-primary);\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.table-row {\n  border-bottom: 1px solid var(--border-primary);\n  transition: all 0.2s;\n  cursor: pointer;\n}\n\n.table-row:hover {\n  background: var(--bg-hover);\n}\n\n.table-row:last-child {\n  border-bottom: none;\n}\n\n.row-main {\n  display: grid;\n  grid-template-columns: 2fr 0.8fr 1fr;\n  gap: 12px;\n  padding: 12px 16px;\n  align-items: center;\n}\n\n.row-expanded {\n  display: none;\n  padding: 0 16px 16px 16px;\n  gap: 12px;\n}\n\n.table-row.expanded .row-expanded {\n  display: flex;\n  animation: slideDown 0.2s ease;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.asset-cell {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.asset-cell input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.asset-cell img,\n.asset-cell video {\n  width: 45px;\n  height: 45px;\n  object-fit: cover;\n  border-radius: 6px;\n  flex-shrink: 0;\n}\n\n.asset-cell span {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-primary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.row-main > span {\n  font-size: 13px;\n  color: var(--text-secondary);\n}\n\n.row-expanded .playlist-select {\n  flex: 1;\n  padding: 10px 12px;\n  border: 1px solid var(--border-primary);\n  border-radius: 8px;\n  font-size: 13px;\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.row-expanded .playlist-select:hover {\n  border-color: var(--accent);\n}\n\n.row-expanded .playlist-select:focus {\n  outline: none;\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.row-expanded button.danger {\n  padding: 10px 20px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-primary);\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.row-expanded button.danger:hover {\n  background: #fef2f2;\n  border-color: #fecaca;\n  color: var(--danger);\n}\n\n[data-theme=\"dark\"] .row-expanded button.danger:hover {\n  background: #7f1d1d;\n  border-color: #991b1b;\n}\n\n/* ==================== BULK ACTION BAR ==================== */\n\n.bulk-bar {\n  position: fixed;\n  bottom: calc(80px + env(safe-area-inset-bottom));\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 12px 20px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-primary);\n  color: var(--text-primary);\n  border-radius: 10px;\n  box-shadow: var(--shadow-lg);\n  z-index: 999;\n  animation: slideUp 0.3s ease;\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateX(-50%) translateY(100px);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(-50%) translateY(0);\n    opacity: 1;\n  }\n}\n\n.bulk-bar span {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.bulk-bar button {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.bulk-bar button.danger {\n  background: var(--danger);\n  color: white;\n}\n\n.bulk-bar button.danger:hover {\n  background: var(--danger-hover);\n}\n\n/* ==================== MODAL ==================== */\n\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n  animation: fadeIn 0.2s ease;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.modal {\n  background: var(--bg-secondary);\n  border-radius: 12px;\n  padding: 24px;\n  max-width: 600px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: var(--shadow-lg);\n  animation: scaleIn 0.2s ease;\n}\n\n@keyframes scaleIn {\n  from {\n    transform: scale(0.9);\n    opacity: 0;\n  }\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.modal h2 {\n  margin: 0 0 20px 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.modal .drop-zone {\n  border: 2px dashed var(--border-secondary);\n  border-radius: 10px;\n  padding: 40px 20px;\n  text-align: center;\n  color: var(--text-secondary);\n  font-size: 14px;\n  margin-bottom: 16px;\n  transition: all 0.2s;\n  cursor: pointer;\n}\n\n.modal .drop-zone:hover {\n  border-color: var(--accent);\n  background: var(--accent-light);\n  color: var(--accent);\n}\n\n.modal input[type=\"file\"] {\n  margin-bottom: 16px;\n  padding: 10px;\n  width: 100%;\n  border: 1px solid var(--border-primary);\n  border-radius: 8px;\n  font-size: 13px;\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  cursor: pointer;\n}\n\n.modal .progress {\n  width: 100%;\n  height: 6px;\n  background: var(--bg-tertiary);\n  border-radius: 6px;\n  overflow: hidden;\n  margin-bottom: 16px;\n}\n\n.modal .progress > div {\n  height: 100%;\n  background: linear-gradient(90deg, var(--accent), var(--accent-hover));\n  transition: width 0.3s ease;\n  border-radius: 6px;\n}\n\n.modal button {\n  width: 100%;\n  padding: 12px 20px;\n  border: 1px solid var(--border-primary);\n  border-radius: 8px;\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.modal button.primary {\n  background: var(--accent);\n  color: white;\n  border-color: var(--accent);\n}\n\n.modal button.primary:hover:not(:disabled) {\n  background: var(--accent-hover);\n  border-color: var(--accent-hover);\n}\n\n.modal button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ==================== UPLOAD PREVIEW GRID ==================== */\n\n.upload-preview-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));\n  gap: 10px;\n  margin-bottom: 16px;\n}\n\n.upload-preview-card {\n  background: var(--bg-tertiary);\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid var(--border-primary);\n}\n\n.upload-preview-card img,\n.upload-preview-card video {\n  width: 100%;\n  height: 110px;\n  object-fit: cover;\n  display: block;\n}\n\n.upload-preview-card span {\n  display: block;\n  padding: 6px;\n  font-size: 11px;\n  color: var(--text-secondary);\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.upload-status {\n  margin-top: 12px;\n}\n\n.upload-status p {\n  font-size: 13px;\n  color: var(--text-secondary);\n  margin-bottom: 8px;\n}\n\n.progress-bar {\n  width: 100%;\n  height: 6px;\n  background: var(--bg-tertiary);\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, var(--accent), var(--success));\n  transition: width 0.3s ease;\n}\n\n/* ==================== RESPONSIVE ==================== */\n\n@media (max-width: 1024px) {\n  .assets-grid {\n    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  }\n\n  .table-header,\n  .row-main {\n    grid-template-columns: 2fr 0.8fr 1fr;\n    gap: 10px;\n    font-size: 11px;\n  }\n}\n\n@media (max-width: 768px) {\n  .assets-toolbar {\n    grid-template-columns: 1fr;\n  }\n\n  .toolbar-search,\n  .toolbar-filters,\n  .toolbar-actions,\n  .add-asset {\n    grid-column: 1;\n    grid-row: auto;\n  }\n\n  .add-asset {\n    align-self: stretch;\n  }\n\n  .table-header {\n    display: none;\n  }\n\n  .row-main {\n    display: block;\n    padding: 16px;\n  }\n\n  .table-row {\n    border-radius: 12px;\n    margin-bottom: 12px;\n  }\n\n  .asset-cell {\n    margin-bottom: 12px;\n  }\n\n  .row-main > span {\n    display: block;\n    margin-bottom: 8px;\n  }\n\n  .row-expanded {\n    padding: 0 16px 16px 16px;\n    flex-direction: column;\n  }\n\n  .row-expanded .playlist-select,\n  .row-expanded button.danger {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
